import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavbarGenerale from "./Navbar";
import Input from "../../components/Input";
import PopUp from "../../components/PopUp";
import { MailCheck } from "lucide-react";
import Alert from "../../components/Alert";
import Button from "../../components/Button";

const Crea = () => {
    const [codiceDominio, setCodiceDominio] = useState("");
    const [ragioneSociale, setRagioneSociale] = useState("");
    const [indirizzo, setIndirizzo] = useState("");
    const [cap, setCap] = useState("");
    const [citta, setCitta] = useState("");
    const [provincia, setProvincia] = useState("");
    const [nomeManager, setNomeManager] = useState("");
    const [cognomeManager, setCognomeManager] = useState("");
    const [emailManager, setEmailManager] = useState("");
    const [passwordManager, setPasswordManager] = useState("");
    const [confermaPasswordManager, setConfermaPasswordManager] = useState("");
    const [codiceVerifica, setCodiceVerifica] = useState("");
    const [codiceInserito, setCodiceInserito] = useState("");
    const [isVerifyVisible, setIsVerifyVisible] = useState(false);
    const [isAssistenzaVisible, setIsAssistenzaVisible] = useState(false);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        if (localStorage.getItem("infoDominio")) {
            const infoDominio = JSON.parse(localStorage.getItem("infoDominio"));
            setCodiceDominio(infoDominio.codice);
            setRagioneSociale(infoDominio.ragione);
            setIndirizzo(infoDominio.indirizzo);
            setCap(infoDominio.cap);
            setCitta(infoDominio.citta);
            setProvincia(infoDominio.provincia);
            setNomeManager(infoDominio.nomeManager);
            setCognomeManager(infoDominio.cognomeManager);
            setEmailManager(infoDominio.emailManager);
            setPasswordManager(infoDominio.passwordManager);
        }
    }, []);

    const checkEmail = async () => {
        if (emailManager === "") return;
        try {
            const r = await fetch('/checkEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: emailManager }),
            });
            if (r.status === 500) {
                const rd = await r.json();
                setAlertInfo({ type: "error", text: rd['error'], onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setEmailManager('');
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel controllo della mail, riprovare più tardi.", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
    };

    const checkCodiceDominio = async () => {
        if (codiceDominio === "") return;
        try {
            const r = await fetch('/checkCodiceDominio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodiceDominio: codiceDominio }),
            });

            if (r.status === 401) {
                const rd = await r.json();
                setAlertInfo({ type: "error", text: rd['error'], onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setCodiceDominio('');
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel controllo del codice del dominio, riprovare più tardi.", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }

    };

    const generateCodiceVerifica = () => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let codice = '';
        for (let i = 0; i < 16; i++) {
            if (i > 0 && i % 4 === 0) {
                codice += '-';
            }
            codice += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return codice;
    };

    const checkDati = () => {
        if (codiceDominio === "" || ragioneSociale === "" || indirizzo === "" || cap === "" || citta === "" || provincia === "" || nomeManager === "" || cognomeManager === "" || emailManager === "" || passwordManager === "" || confermaPasswordManager === "") {
            setAlertInfo({ type: "warning", text: "Compilare tutti i campi obbligatori (*)", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return false;
        }
        if (passwordManager !== confermaPasswordManager) {
            setAlertInfo({ type: "warning", text: "Le password non coincidono", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return false;
        }
        return true;
    };

    const checkPassword = () => {
        if (passwordManager === "") return;

        let check = true;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const numberPattern = /[0-9]/;

        if (!uppercasePattern.test(passwordManager)) {
            check = false;
        }
        if (!lowercasePattern.test(passwordManager)) {
            check = false;
        }
        if (!specialCharPattern.test(passwordManager)) {
            check = false;
        }
        if (!numberPattern.test(passwordManager)) {
            check = false;
        }
        if (passwordManager.length < 8) {
            check = false;
        }

        if (!check) {
            setAlertInfo({ type: "warning", text: "La password deve rispettare i criteri indicati", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
    };

    const checkCodiceVerifica = () => {
        if (codiceInserito === codiceVerifica && isVerifyVisible) {
            localStorage.setItem("successVerify", "true");
            setAlertInfo({ type: "success", text: "Codice corretto", onClose: () => navigate('/attiva'), needConfirm: false });
            setShowAlert(true);
        };
    };

    const handleVerifica = () => {
        if (!checkDati()) return;

        let items = {
            codice: codiceDominio,
            ragione: ragioneSociale,
            indirizzo: indirizzo,
            cap: cap,
            citta: citta,
            provincia: provincia,
            nomeManager: nomeManager,
            cognomeManager: cognomeManager,
            emailManager: emailManager,
            passwordManager: passwordManager
        };
        localStorage.setItem("infoDominio", JSON.stringify(items));

        handleCodiceVerifica();
    };

    const handleCodiceVerifica = async () => {
        const codice = generateCodiceVerifica();
        try {
            const r = await fetch('/sendCodiceVerifica', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: emailManager, Codice: codice }),
            });

            if (r.status === 500) {
                const rd = await r.json();
                setAlertInfo({ type: "error", text: rd['error'], onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                return;
            }
            else {
                setCodiceVerifica(codice);
                setIsVerifyVisible(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'invio della mail di verifica, riprovare più tardi.", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
    };

    return (
        <div className="h-[100svh]">
            <NavbarGenerale />
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto flex flex-col justify-center items-center">
                <p>CREA IL TUO DOMINIO</p>
                <p>
                    oppure
                    <span
                        className="text-blue-600 underline font-semibold hover:cursor-pointer ml-1"
                        onClick={() => { localStorage.removeItem("infoDominio"); navigate('/'); }}
                    >
                        esegui la login
                    </span>
                </p>
                <Input
                    label="Codice/P.IVA *"
                    value={codiceDominio}
                    setValue={setCodiceDominio}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-1"
                    disabled={false}
                    error={false}
                    blurAction={checkCodiceDominio}
                />
                <Input
                    label="Ragione Sociale *"
                    value={ragioneSociale}
                    setValue={setRagioneSociale}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                />
                <Input
                    label="Indirizzo *"
                    value={indirizzo}
                    setValue={setIndirizzo}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                />
                <Input
                    label="CAP *"
                    value={cap}
                    setValue={setCap}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                />
                <Input
                    label="Città *"
                    value={citta}
                    setValue={setCitta}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                />
                <Input
                    label="Provincia *"
                    value={provincia}
                    setValue={setProvincia}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                />
                <p className="mt-8">Informazioni del manager</p>
                <Input
                    label="Nome *"
                    value={nomeManager}
                    setValue={setNomeManager}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-1"
                    disabled={false}
                    error={false}
                />
                <Input
                    label="Cognome *"
                    value={cognomeManager}
                    setValue={setCognomeManager}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                />
                <Input
                    label="Email *"
                    value={emailManager}
                    setValue={setEmailManager}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                    blurAction={checkEmail}
                />
                <Input
                    label="Password *"
                    value={passwordManager}
                    setValue={setPasswordManager}
                    type="password"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                    blurAction={checkPassword}
                    info={true}
                    infotext='La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale ( es. [!@#$%^&*(),.?":{}|<>])'
                    infopos="l"
                />
                <Input
                    label="Conferma Password *"
                    value={confermaPasswordManager}
                    setValue={setConfermaPasswordManager}
                    type="password"
                    classes="w-[80%] md:w-[50%] mt-3"
                    disabled={false}
                    error={false}
                />
                <Button type="full" classes="w-[80%] md:w-[50%] mt-3" onClick={handleVerifica}>
                    VERIFICA <MailCheck size={20} className="inline ml-1" />
                </Button>
                <PopUp
                    title="VERIFICA MAIL"
                    isVisible={isVerifyVisible}
                    setIsVisible={setIsVerifyVisible}
                    needConfirm={false}
                >
                    <div className="flex flex-col items-center">
                        <Input
                            label="Codice di verifica *"
                            value={codiceInserito}
                            setValue={setCodiceInserito}
                            type="text"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                            blurAction={checkCodiceVerifica}
                        />
                        <span className="text-blue-600 underline font-semibold hover:cursor-pointer mt-4" onClick={() => setIsAssistenzaVisible(true)}>Hai problemi con la mail di verifica?</span>
                    </div>
                    <PopUp
                        title="ASSISTENZA"
                        isVisible={isAssistenzaVisible}
                        setIsVisible={setIsAssistenzaVisible}
                        needConfirm={false}
                    >
                        <>
                            <p>Se non ricevi la mail di verifica, segui questi passaggi:</p>
                            <p>1. Controlla che l'indirizzo email inserito sia corretto</p>
                            <p>2. Controlla che la mail non sia finita nello spam</p>
                            <p>3. Controlla che la casella di posta non sia piena</p>
                            <p>4. Se non è nessuno di questi aspetta qualche minuto e riprova a verificare la mail</p>
                            <p>5. Se non funziona ancora, invia una mail a 'support@mantego.cloud' con le informazioni di contatto</p>
                        </>
                    </PopUp>
                </PopUp>
            </div>
        </div>
    )
};
export default Crea;
